import styled from 'styled-components';
import { ob } from 'components/Onboarding';

export const Layout = styled.div`
  display: grid;
  align-items: start;
  gap: 32px;
  @media (min-width: 1024px) {
    grid-template-columns: 1.6fr 1fr;
    gap: 48px;
  }
`;

export const Side = styled.div`
  @media (min-width: 1024px) {
    position: sticky;
    top: 96px;
    padding-left: 48px;
    border-left: 1px solid rgba(238, 235, 230, 0.7);
  }
`;

export const MainCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SearchWrap = styled.div`
  position: relative;
  svg {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: ${ob.muted};
  }
  input {
    width: 100%;
    height: 48px;
    padding: 0 14px 0 42px;
    border: 1px solid ${ob.border};
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 1px 1px rgba(26, 26, 26, 0.03);
    font-family: inherit;
    font-size: 14px;
    color: ${ob.text};
    &::placeholder {
      color: ${ob.muted};
      opacity: 0.8;
    }
    &:focus {
      outline: none;
      border-color: ${ob.primary};
      box-shadow: 0 0 0 3px ${ob.ring};
    }
  }
`;

export const GroupCard = styled.section`
  padding: 16px;
  border: 1px solid ${ob.border};
  border-radius: 16px;
  background: ${ob.card};
  box-shadow: 0 1px 2px rgba(26, 26, 26, 0.04);
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
  }
  h3 {
    margin: 0;
    font-family: ${ob.fontDisplay};
    font-size: 14px;
    font-weight: 600;
    color: ${ob.text};
  }
  .count {
    flex-shrink: 0;
    padding: 2px 8px;
    border-radius: 999px;
    background: ${ob.primarySoft};
    color: ${ob.primary};
    font-size: 11px;
    font-weight: 600;
  }
  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
`;

export const AmenityChip = styled.button<{ $selected?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px 0 10px;
  border: 1px solid ${({ $selected }) => ($selected ? ob.primary : ob.border)};
  border-radius: 999px;
  background: ${({ $selected }) => ($selected ? ob.primarySoft : '#faf9f7')};
  box-shadow: ${({ $selected }) => ($selected ? '0 1px 2px rgba(26,26,26,0.05)' : 'none')};
  color: ${({ $selected }) => ($selected ? ob.text : 'rgba(26,26,26,0.8)')};
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 140ms ease;
  &:hover {
    border-color: rgba(255, 113, 15, 0.4);
  }
  &:active {
    transform: scale(0.97);
  }
  img {
    width: 16px;
    height: 16px;
    object-fit: contain;
    flex-shrink: 0;
  }
  svg {
    flex-shrink: 0;
    color: ${ob.primary};
  }
`;

/* Optional details that open under the group when pool / parking / flexible check-in is picked. */
export const FollowUp = styled.div`
  margin-top: 14px;
  padding: 12px 14px 14px;
  border: 1px solid rgba(255, 113, 15, 0.25);
  border-radius: 12px;
  background: rgba(255, 240, 230, 0.4);
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 8px;
  }
  .title {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: ${ob.text};
  }
  .close {
    width: 24px;
    height: 24px;
    padding: 0;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: ${ob.muted};
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    &:hover {
      background: ${ob.mutedBg};
      color: ${ob.text};
    }
  }
  .row {
    display: flex;
    gap: 8px;
  }
  .micro {
    display: flex;
    flex: 1 1 0;
    min-width: 0;
    align-items: center;
    gap: 4px;
    span {
      width: 12px;
      flex-shrink: 0;
      text-align: center;
      font-size: 10px;
      font-weight: 700;
      color: ${ob.muted};
    }
  }
  .labeled {
    display: flex;
    align-items: center;
    gap: 8px;
    span {
      flex-shrink: 0;
      font-size: 12px;
      font-weight: 600;
      color: ${ob.muted};
    }
  }
  input,
  select,
  textarea {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding: 0 10px;
    border: 1px solid ${ob.border};
    border-radius: 10px;
    background: #fff;
    font-family: inherit;
    font-size: 13px;
    &:focus {
      outline: none;
      border-color: ${ob.primary};
      box-shadow: 0 0 0 3px ${ob.ring};
    }
  }
  input,
  select {
    height: 38px;
  }
  textarea {
    padding: 8px 10px;
    line-height: 1.45;
    resize: vertical;
  }
`;

export const ReopenButton = styled.button`
  margin-top: 12px;
  height: 32px;
  padding: 0 12px;
  border: 1px dashed ${ob.primary};
  border-radius: 999px;
  background: ${ob.primarySoft};
  color: ${ob.primary};
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
`;

export const SwitchStack = styled.div`
  display: grid;
  gap: 12px;
`;
